import { FormikErrors } from 'formik';

import { NameAndPlatformValues } from './NameAndPlatform.types';

export const NameAndPlatformValidate = (fields: NameAndPlatformValues) => {
  let errors: FormikErrors<NameAndPlatformValues> = {};
  if (!fields.name) {
    errors.name = 'Mandatory';
  }
  if (!fields.platforms || !fields.platforms.length) {
    errors.platforms = 'Select Min 1 ';
  }
  return errors;
};
